import { render } from "./TheSwitch.vue?vue&type=template&id=d34473b0&scoped=true"
import script from "./TheSwitch.vue?vue&type=script&lang=js"
export * from "./TheSwitch.vue?vue&type=script&lang=js"

import "./TheSwitch.vue?vue&type=style&index=0&id=d34473b0&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d34473b0"]])

export default __exports__